<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>快捷用印</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn
          round
          small
          color="orange darken-1"
          class="white--text"
          @click.native.stop="() => { editDbid = null; edit = true; }">
        <v-icon dark small>table_chart</v-icon>用印申请
      </v-btn>
    </v-toolbar>

    <v-divider/>

    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-autocomplete
                  v-model="form.sealQuickId"
                  item-text="name"
                  item-value="dbid"
                  label="选择业务"
                  :items="sealQuickItems"
                  hide-details
                  clearable
                  :menu-props="{ maxHeight: 450 }"
              />
            </v-flex>


            <v-flex xs12 sm4>

            </v-flex>

            <v-flex d-flex xs2 text-xs-right>
              <div>
                <v-btn color="primary" @click="onSearch">
                  <v-icon dark>search</v-icon>
                  检索
                </v-btn>
              </div>
            </v-flex>

          </v-layout>
        </v-flex>
      </v-layout>

    </v-container>

    <v-divider/>

    <v-data-table
        :headers="headers"
        :loading="loading"
        item-key="dbid"
        :pagination.sync="query"
        :items="pageResult.items"
        :total-items="pageResult.total"
        :rows-per-page-items="[10, 25, 50, 100, 200]"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>
          <span style="font-weight: bold">{{ props.item.name }}</span>
        </td>
        <td>
          {{ props.item.proj ? props.item.proj.name : '—' }}
        </td>
        <td>
          {{ formatDate(props.item.crtDate) }}
        </td>

        <td>
          <a target="_blank" @click.stop="printDisabled(props.item) ? null : downloadSealPdf(props.item.dbid)">
            <v-chip small
                    label
                    dark
                    class="mr-1"
                    :class="{ 'disabled-chip': printDisabled(props.item) }"
                    :color="printDisabled(props.item) ? 'grey' : 'green'"
                    :disabled = "printDisabled(props.item)">
              用印单
            </v-chip>
          </a>

          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
        </td>

        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { editDbid = props.item.dbid; edit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { rowIdx = props.index; submitDbid = props.item.dbid; submitMsg = props.item.name; submit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">publish</v-icon>
            </v-btn>
            <span>提交</span>
          </v-tooltip>

          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }"
                   :disabled="deleteDisabled(props.item)">
              <v-icon color="pink">delete_forever</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>

      </template>
    </v-data-table>

    <x-history
        v-model="hist"
        :history="history"
        :status="statusItems"
    />

    <x-delete
        v-model="dele"
        :message="deleMsg"
        :uri="uri"
        :dbid="deleDbid"
        v-on:ok="onDeleOk"
    />

    <x-edit
        v-model="edit"
        :dbid="editDbid"
        v-on:ok="onEditOk"
    />

    <x-submit
        v-model="submit"
        :dbid="submitDbid"
        :message="submitMsg"
        :uri="uri"
        @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

    <x-view
        v-model="view"
        :dbid="viewDbid"
    />


  </v-card>

</template>

<script>
import mixin from "@/mixin";
import XHistory from "@/components/seal/SealQuickHistory"
import XDelete from '@/components/global/Delete'
import XSubmit from '@/components/global/Submit'
import XView from './View'
const baseUri = '/api/seal/quick/by/request/single/user';
const getSealQuick = '/api/seal/quick/get/Seal/Quick';
import XEdit from './Edit';
import {mapGetters} from "vuex";
export default {
  // 混入模块列表页面（index）基本功能
  mixins: [mixin.index(baseUri)],
  components: {XView, XHistory, XDelete, XEdit, XSubmit},
  data() {
    return {

      uri: '/api/seal/quick',

      sealQuickItems: [],

      // 检索、分页、排序条件条件
      query: {
        statusId: '',
        sealQuickId: '',

        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        descending: null,
        totalItems: null
      },

      // 检索框
      form: {
        statusId: '',
        sealQuickId: '',
      },

      hist: false,
      history: [],
      statusItems: [],

      dele: false,
      deleDbid: null,
      deleMsg: null,

      edit: false,
      editDbid: null,

      submit: false,
      submitDbid: null,
      submitMsg: null,

      view: false,
      viewDbid: null,

      // 表头
      headers: [
        {text: '#', align: 'left', sortable: false, value: 'dbid',width: "5%"},
        {text: '快捷用印业务', align: 'left', sortable: true, value: 'name',width: "30%"},
        {text: '关联项目', align: 'left', sortable: true, value: 'proj',width: "15%"},
        {text: '报审日期', align: 'left', sortable: true, value: 'crtDate',width: "15%"},
        {text: '状态', align: 'center', sortable: true, value: 'status',width: "10%"},
        {text: '操作', align: 'center', sortable: false, value: 'dbid',width: "5%"}
      ],

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
      }

    }
  },

  created() {
    // 加载审核状态
    const vm = this
    const sealQuickUrl = '/api/code/status/sealQuick/';
    this.axios.all([
      this.axios.get(sealQuickUrl, {params: {sort: 'rank.asc'}}),
      this.axios.get(getSealQuick, {params: {limit: 65535, disabled: 'F', userId:vm.userId}}),
    ]).then(
        this.axios.spread(
            (rspStaus, rspSeal) => {
              vm.statusItems = rspStaus.data.items;
              vm.sealQuickItems = rspSeal.data.items;
            }
        )
    )
  },

  computed: {
    ...mapGetters(['userId','deptId','deptName','username', 'funcIds'])
  },

  methods: {
    // 检索响应函数
    onSearch() {
      //此段代码解决状态为全部但不显示数据的问题
      if (this.form.statusId === 0) {
        this.form.statusId = ''
      }
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.doRoute(this.query);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const d = new Date(dateString);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },

    deleteDisabled(item) {
      return !(
          // 当前用户拥有提交功能
          this.funcIds.includes('d_seal')
          // 并且，当前记录需要提交
          && item.actions.find(a => a.action === 'submit'))
    },

    submitDisabled(item) {
      return !(
          // 当前用户拥有提交功能
          this.funcIds.includes('c_seal')
          // 并且，当前记录需要提交
          && item.actions.find(a => a.action === 'submit'))
    },

    printDisabled(item) {
      return !(
          item.statusId  === 'checked')
    },

    downloadSealPdf(dbid) {
      // window.console.log("sealPdfUrl");
      const url = `${this.uri}/seal/${dbid}`
      const urlWithToken =  window.xutil.buildUrl(url, {})
      window.open(urlWithToken, "__blank")
    },
  }



}
</script>

<style scoped>

</style>